import React from "react";

function Saveicon() {
    return (
        <svg xmlns=" http://www.w3.org/2000/svg" viewBox="0 0 480 480">
            <path
                d="m413.664062 2.351562c-.738281-.738281-1.617187-1.324218-2.585937-1.726562-.972656-.414062-2.019531-.625-3.078125-.625h-400c-4.417969 0-8 3.582031-8 8v464c0 4.417969 3.582031 8 8 8h464c4.417969 0 8-3.582031 8-8v-400c0-2.121094-.84375-4.15625-2.34375-5.65625zm-333.664062 13.648438h320v112h-320zm320 448h-320v-176h320zm0-192h-320v-16h320zm64 192h-48v-216c0-4.417969-3.582031-8-8-8h-336c-4.417969 0-8 3.582031-8 8v216h-48v-448h48v120c0 4.417969 3.582031 8 8 8h336c4.417969 0 8-3.582031 8-8v-108.6875l48 48zm0 0"
                dth="15px"
            />
            <path d="m413.664062 2.351562c-.738281-.738281-1.617187-1.324218-2.585937-1.726562-.972656-.414062-2.019531-.625-3.078125-.625h-400c-4.417969 0-8 3.582031-8 8v464c0 4.417969 3.582031 8 8 8h464c4.417969 0 8-3.582031 8-8v-400c0-2.121094-.84375-4.15625-2.34375-5.65625zm-333.664062 13.648438h320v112h-320zm320 448h-320v-176h320zm0-192h-320v-16h320zm64 192h-48v-216c0-4.417969-3.582031-8-8-8h-336c-4.417969 0-8 3.582031-8 8v216h-48v-448h48v120c0 4.417969 3.582031 8 8 8h336c4.417969 0 8-3.582031 8-8v-108.6875l48 48zm0 0" />
            <path d="m360 32h-48c-4.417969 0-8 3.582031-8 8v64c0 4.417969 3.582031 8 8 8h48c4.417969 0 8-3.582031 8-8v-64c0-4.417969-3.582031-8-8-8zm-8 64h-32v-48h32zm0 0" />
            <path d="m32 32h16v16h-16zm0 0" />
            <path d="m32 432h16v16h-16zm0 0" />
            <path d="m432 432h16v16h-16zm0 0" />
            <path d="m128 448v-16h-16v-16h-16v32zm0 0" />
            <path d="m384 448v-32h-16v16h-16v16zm0 0" />
        </svg>
    );
}

export default Saveicon;